export default __webpack_public_path__ + "static/media/ahm-logo1.7ed152d4.jpg";